module.exports = "/assets/data/5374499a21cf97db650a54fbe680d5ae-SG1.data.json";